module.exports = __webpack_public_path__ + "img/通知-进度底图.b95e81e0.png";